import type { FunctionComponent, ReactNode } from 'react';

type ShakeAnimationProps = {
    readonly children: ReactNode;
    readonly isShaking: boolean;
};

export const ShakeAnimation: FunctionComponent<ShakeAnimationProps> = ({ children, isShaking }) => (
    <div
        className={`relative z-[2] h-full w-full will-change-transform ${isShaking ? 'motion-safe:animate-shake' : ''}`}
    >
        {children}
    </div>
);
